import gsap, { Power3, Linear, ScrollToPlugin } from "gsap/all";
import axios from "axios";
import $ from "jquery";

gsap.registerPlugin(Power3, Linear, ScrollToPlugin);

const isLocal = (location.hostname === "localhost" || location.hostname === "127.0.0.1" || location.hostname === "");


const formQuiz = $('#formQuiz'),
      participationForm = $('#participationForm');


if(formQuiz.length){
    function formQuizHandler(){
        const   form = $('#formQuiz'),
                advice = $('#advice'),
                errorText = $('.form__error'),
                btnSubmit = $('#btnSubmit');

        $(advice).on('input', () => {
            if ($(advice).val().length < 1) {
                $(advice).next(".error").removeClass("hidden");
                return false;
            } else {
                $(advice).next(".error").addClass("hidden");
            }
        })
        
        $(form).on('submit', function(e) {
            e.preventDefault();

            if ($(advice).val().length < 1) {
                $(advice).next(".error").removeClass("hidden");
                return false;
            };

            $(form).addClass('is-sending');
            $(btnSubmit).attr('disabled');

            // data
            localStorage.setItem('adviceText', $(advice).val());

            if(isLocal){
                window.location.href = 'contest-form.html';
            } else {
                window.location.href = 'contest-form?lang=' + locale;
            }
        });
    }
    formQuizHandler();
}

if(participationForm.length){
    function formHandler() {
        const form = $(participationForm),
              nameInput = $('#userName'),
              emailInput = $('#userEmail'),
              emailErrorEmpty = $(".error-email-empty"),
              emailErrorIncorrect = $(".error-email-incorrect"),
              emailReg = /\S+@\S+\.\S+/,
              formAnswers = $('.contest-form__answer'),
              adviceText = localStorage.getItem('adviceText'),
              btn = document.getElementById('btnParticipation'),
              cbx1 = $('#privacy');
        var answer = '';

        function scrollToError(field) {
            const offsetY = $(".header").height() + 100;
            const tl = gsap.timeline();
            tl.to(window, {
                duration: 0.6,
                scrollTo: {
                    y: field,
                    offsetY,
                },
                ease: window.Linear,
            });
        }

        var checker = false;

        function checkFormFields() {
            if ($(nameInput).val().trim() === "") {
                scrollToError(nameInput);
                setError(nameInput, true);
            }
            if ($(emailInput).val().trim() === '') {
                scrollToError(emailInput);
                setError(emailInput, true);
            }

            formAnswers.each(function() {
                if ($(this).prop('checked') == true) {
                    checker = true;
                    answer = $(this).val();
                }
            });

            if (checker == false) {
                $('.form__line-answers .error').removeClass('hidden');
                return false;
            } else {
                $('.form__line-answers .error').addClass('hidden');
            }

            return true;
        }

        $(nameInput).on('input', ()=>{
            if ($(nameInput).val().trim() === "") {
                setError(nameInput, true);
            } else {
                setError(nameInput, false);
            }
        })

        $(emailInput).on('input', ()=>{
            if ($(emailInput).val().trim() === "") {
                setError(emailInput, true);
            } else {
                setError(emailInput, false);
            }
        })

        formAnswers.each(function() {
            $(this).on('change', ()=> {
                $('.form__line-answers .error').addClass('hidden');
            })
        });

        function setError(e, status) {
            if (status) {
                $(e).addClass('is-error');
                $(e).next('.error').removeClass('hidden');
            } else {
                $(e).removeClass('is-error').removeClass('is-correct');
                $(e).next('.error').addClass('hidden');
            }
        }

        $(cbx1).on('change', () => {
            if ($(cbx1).prop('checked') === true) {
                $(btn).removeAttr('disabled');
            } else {
                $(btn).attr('disabled', 'disabled');
            }
        });

        function resetForm() {
            setTimeout(() => {
                $(form).removeClass('is-sending');
                $(form)[0].reset()
            }, 3000);
        }

        $(btn).on('click', async function (e) {
            e.preventDefault();
            if (!checkFormFields()) return;

            const token = await grecaptcha.execute(tokenCaptcha, {
                action: "submit",
            });

            const formD = {
                name: $(nameInput).val(),
                email: $(emailInput).val(),
                privacy: $(cbx1).prop('checked'),
                advice: adviceText,
                purchased_boni_products: answer,
                "g-recaptcha-response": token
            };
            
            $(form).addClass('is-sending');
            $(btn).attr('disabled', 'disabled')

            if (isLocal) {
                console.table(formD);
                $(form).removeClass('is-sending');
                $('body').addClass('show-modal');
                $('#captchaInvalid').addClass('is-open');
                $(btn).removeAttr('disabled');
            }

            try {
                const response = axios({
                    method: 'post',
                    url: $(form).attr('action'),
                    data: formD,
                    headers: {
                        'Content-Type': 'applicataion/json',
                    },
                });
                
                response.then((response) => {
                    if(response.status === 200){
                        if (!response.data.captcha_is_valid) {
                            $(form).removeClass('is-sending');
                            $('body').addClass('show-modal');
                            $('#captchaInvalid').addClass('is-open');
                            $(btn).removeAttr('disabled');
                            return;
                        }

                        if (response.data?.already_participated_today){
                            $(form).removeClass('is-sending');
                            $('body').addClass('show-modal');
                            $('#popupAlreadyParticipated').addClass('is-open');
                            resetForm();
                            return;
                        }

                        window.location.href = 'win?lang=' + locale;
                    } else {
                        $(form).removeClass('is-sending');
                        alert(response.message);
                        $(btn).removeAttr('disabled');
                    }
                });

            } catch (err) {
                alert(err.message);
                $(form).removeClass('is-sending');
                $(btn).removeAttr('disabled');
            } finally {
            }
        });
    }

    formHandler()
}

